var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';

import "./FieldCode.scss";

var FieldCode = (_temp = _class = function (_Component) {
    _inherits(FieldCode, _Component);

    function FieldCode(props) {
        _classCallCheck(this, FieldCode);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.onBlur = function (event) {
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };

        _this.onFocus = function (event) {
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };

        _this.onBeforeChange = function (editor, data, value) {

            _this.setState({
                value: value
            });

            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };

        _this.getClassName = function () {
            var _this$props = _this.props,
                className = _this$props.className,
                type = _this$props.type;


            var classNames = [];

            classNames.push('admin-field');
            classNames.push('field--code');

            return classNames.join(' ');
        };

        _this.state = {
            value: props.value
        };
        return _this;
    }

    FieldCode.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            type = _props.type,
            options = _props.options,
            value = _props.value;


        var className = this.getClassName();

        return React.createElement(
            'div',
            { className: className },
            React.createElement(CodeMirror, {
                value: value,
                options: options,
                onBeforeChange: this.onBeforeChange
            })
        );
    };

    return FieldCode;
}(Component), _class.defaultProps = {
    type: "text",
    value: "",
    required: false,
    autofocus: false,
    options: {
        theme: "default",
        height: "auto",
        viewPortMargin: "infinity",
        mode: {
            name: "javascript",
            json: true,
            statementIndent: 2
        },
        lineNumbers: true,
        lineWrapping: true,
        indentWithTabs: false,
        tabSize: 2
    }
}, _temp);


export default FieldCode;